import React from "react";
import styled from "styled-components";
import { makeStyles } from "@material-ui/core/styles";
import FormLabel from "@material-ui/core/FormLabel";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Zoom from "@material-ui/core/Zoom";
import CheckIcon from "@material-ui/icons/Check";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex"
  },
  formControl: {
    margin: 0,
    width: "100%"
  },
  formLabel: {
    marginBottom: theme.spacing(1),
    textAlign: "center"
  },
  formGroup: {
    flexDirection: "row",
    justifyContent: "space-between"
  },
  formControlLabel: {
    marginLeft: 0,
    marginRight: 0,
    width: "25%",
    justifyContent: "center",
    alignItems: "baseline",
    textAlign: "center"
  }
}));

export default function CheckboxGroup({ options, value, onChange, label, ...props}) {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <FormControl component="fieldset" className={classes.formControl} {...props}>
        {label && (
          <FormLabel className={classes.formLabel} component="legend">
            {label}
          </FormLabel>
        )}
        <StyledFormGroup className={classes.formGroup}>
          {options.map(o => {
            const active = value.includes(o.value);
            return (
              <FormControlLabel
                className={classes.formControlLabel}
                key={o.value}
                control={
                  <Checkbox
                    checked={active}
                    onChange={() => onChange(o.value)}
                    value={o.value}
                    style={{
                      position: "absolute",
                      opacity: 0
                    }}
                  />
                }
                label={
                  <Label active={active}>
                    <ControlButton active={active} bgcolor={o.color}>
                      <Zoom in={active}>
                        <CheckIcon style={{ color: "#fff" }} />
                      </Zoom>
                    </ControlButton>
                    <span>{o.label}</span>
                  </Label>
                }
              />
            );
          })}
        </StyledFormGroup>
      </FormControl>
    </div>
  );
}

const ControlButton = styled.div`
  width: ${props => props.theme.spacing(6)}px;
  height: ${props => props.theme.spacing(6)}px;
  background-color: ${({active, bgcolor, theme}) => active ? bgcolor : 'transparent'};
  border: 4px solid transparent;
  transition: all 250ms cubic-bezier(0.165, 0.84, 0.44, 1);
  opacity: ${props => (props.active ? 1 : 0.4)};
  transform: ${props => (props.active ? "scale(1)" : "scale(0.8)")};
  border-color: ${({active, bgcolor, theme}) =>
    active ? bgcolor : theme.palette.grey400};
  border-radius: 4px;
  margin-bottom: ${props => props.theme.spacing(1)}px;
  display: flex;
  justify-content: center;
  align-items:center;

  > *, + span {
    position: relative;
    z-index: 1;
  }

  &:after{
    content: "";
    z-index: 0;
    background-color: ${({active, bgcolor, theme}) => active ? bgcolor : theme.palette.grey400};
    position: absolute;
    width: ${props => props.theme.spacing(12)}px;
    height: ${props => props.theme.spacing(12)}px;
    border-radius: ${props => props.theme.spacing(6)}px;
    opacity: 0;
    transform: scale(.5);
    transition: all 250ms cubic-bezier(0.175, 0.885, 0.32, 1.275);
  }
`;

const StyledFormGroup = styled(FormGroup)`
  .Mui-focusVisible + span ${ControlButton}:after {
    transform: scale(1);
    opacity: .5;
  }
`;

const Label = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  font-size: 12px;
  color: ${props =>
    props.active ? props.theme.palette.grey800 : props.theme.palette.grey400};
  font-weight: ${props => (props.active ? "bold" : "normal")};
`;
